export default __webpack_public_path__ + "static/media/donut-07.6e0555e8.png";